import jsLogic from 'json-logic-js'
import logBase from './logger'

const log = logBase.extend('Utils')

const DAY_IN_MS = 1000 * 60 * 60 * 24

const isGGSNetwork = (networkId: string, allowNetworks: number[]) => {
  return allowNetworks.includes(Number.parseInt(networkId, 10))
}

const showAdsReturnedPlayer = (dateReturnedPlayingInSeconds: number, delayInDays: number) => {
  const wasPlayerInactive = dateReturnedPlayingInSeconds !== -1
  if (wasPlayerInactive) {
    return isExpired(dateReturnedPlayingInSeconds, delayInDays)
  }

  return true
}

const isExpired = (date: number, delayInDays: number) => {
  if (typeof date === 'number' && /\d{10}/.test(`${date}`)) {
    date *= 1000 // Convert timestamp to ms
  }

  return Date.now() - date >= delayInDays * DAY_IN_MS
}

export const enhanceJSLogic = () => {
  jsLogic.add_operation('isGGSNetwork', isGGSNetwork)
  jsLogic.add_operation('showAdsReturnedPlayer', showAdsReturnedPlayer)
  jsLogic.add_operation('isExpired', isExpired)
}

export const getQueryParameter = (key: string) => {
  return new URL(location.href).searchParams.get(key)
}

export const loadScript = (src: string) => {
  return new Promise<void>(function (resolve, reject) {
    const script = document.createElement('script') as HTMLScriptElement
    script.src = src
    script.addEventListener('load', function () {
      log(`Script loaded: ${src}`)
      resolve()
    })
    script.addEventListener('error', function (e) {
      log(`Error loading script: ${src}  %O`, e)
      reject(e)
    })
    document.head.append(script)
  })
}

export const delay = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
